const NAME_SPACE = 'Profiles'

const constants = {
  FETCH_COMPLETE_SSO_PROVISION_FAILURE: `${NAME_SPACE}/FETCH_COMPLETE_SSO_PROVISION_FAILURE`,
  FETCH_COMPLETE_SSO_PROVISION_REQUEST: `${NAME_SPACE}/FETCH_COMPLETE_SSO_PROVISION_REQUEST`,
  FETCH_COMPLETE_SSO_PROVISION_SUCCESS: `${NAME_SPACE}/FETCH_COMPLETE_SSO_PROVISION_SUCCESS`,
  FETCH_COMPLETE_SSO_PROVISION: `${NAME_SPACE}/FETCH_COMPLETE_SSO_PROVISION`,
  FETCH_CREATE_USER_FAILURE: `${NAME_SPACE}/FETCH_CREATE_USER_FAILURE`,
  FETCH_CREATE_USER_REQUEST: `${NAME_SPACE}/FETCH_CREATE_USER_REQUEST`,
  FETCH_CREATE_USER_SUCCESS: `${NAME_SPACE}/FETCH_CREATE_USER_SUCCESS`,
  FETCH_CREATE_USER: `${NAME_SPACE}/FETCH_CREATE_USER`,
  FETCH_DELETE_PROFILE_FAILURE: `${NAME_SPACE}/FETCH_DELETE_PROFILE_FAILURE`,
  FETCH_DELETE_PROFILE_REQUEST: `${NAME_SPACE}/FETCH_DELETE_PROFILE_REQUEST`,
  FETCH_DELETE_PROFILE_SUCCESS: `${NAME_SPACE}/FETCH_DELETE_PROFILE_SUCCESS`,
  FETCH_DELETE_PROFILE: `${NAME_SPACE}/FETCH_DELETE_PROFILE`,
  EDIT_DEPARTMENT_FAILURE: `${NAME_SPACE}/EDIT_DEPARTMENT_FAILURE`,
  EDIT_DEPARTMENT_REQUEST: `${NAME_SPACE}/EDIT_DEPARTMENT_REQUEST`,
  EDIT_DEPARTMENT_SUCCESS: `${NAME_SPACE}/EDIT_DEPARTMENT_SUCCESS`,
  EDIT_DEPARTMENT: `${NAME_SPACE}/EDIT_DEPARTMENT`,
  FETCH_EDIT_PROFILE_FAILURE: `${NAME_SPACE}/FETCH_EDIT_PROFILE_FAILURE`,
  FETCH_EDIT_PROFILE_REQUEST: `${NAME_SPACE}/FETCH_EDIT_PROFILE_REQUEST`,
  FETCH_EDIT_PROFILE_SUCCESS: `${NAME_SPACE}/FETCH_EDIT_PROFILE_SUCCESS`,
  FETCH_EDIT_PROFILE: `${NAME_SPACE}/FETCH_EDIT_PROFILE`,
  FETCH_UPDATE_AVATAR_FAILURE: `${NAME_SPACE}/FETCH_UPDATE_AVATAR_FAILURE`,
  FETCH_UPDATE_AVATAR_REQUEST: `${NAME_SPACE}/FETCH_UPDATE_AVATAR_REQUEST`,
  FETCH_UPDATE_AVATAR_SUCCESS: `${NAME_SPACE}/FETCH_UPDATE_AVATAR_SUCCESS`,
  FETCH_UPDATE_AVATAR: `${NAME_SPACE}/FETCH_UPDATE_AVATAR`,
  COMPLETE_INTERSTITIAL_REQUEST: `${NAME_SPACE}/COMPLETE_INTERSTITIAL_REQUEST`,
  COMPLETE_INTERSTITIAL_SUCCESS: `${NAME_SPACE}/COMPLETE_INTERSTITIAL_SUCCESS`,
  COMPLETE_INTERSTITIAL_FAILURE: `${NAME_SPACE}/COMPLETE_INTERSTITIAL_FAILURE`,
  COMPLETE_INTERSTITIAL: `${NAME_SPACE}/COMPLETE_INTERSTITIAL`,
  FETCH_NETWORK_REVEAL_REQUEST: `${NAME_SPACE}/FETCH_NETWORK_REVEAL_REQUEST`,
  FETCH_NETWORK_REVEAL_SUCCESS: `${NAME_SPACE}/FETCH_NETWORK_REVEAL_SUCCESS`,
  FETCH_NETWORK_REVEAL_FAILURE: `${NAME_SPACE}/FETCH_NETWORK_REVEAL_FAILURE`,
  FETCH_NETWORK_REVEAL: `${NAME_SPACE}/FETCH_NETWORK_REVEAL`,
  FETCH_WORKING_CIRCLE_REQUEST: `${NAME_SPACE}/FETCH_WORKING_CIRCLE_REQUEST`,
  FETCH_WORKING_CIRCLE_SUCCESS: `${NAME_SPACE}/FETCH_WORKING_CIRCLE_SUCCESS`,
  FETCH_WORKING_CIRCLE_FAILURE: `${NAME_SPACE}/FETCH_WORKING_CIRCLE_FAILURE`,
  FETCH_WORKING_CIRCLE: `${NAME_SPACE}/FETCH_WORKING_CIRCLE`,
  FETCH_ADD_WORKING_CIRCLE_MEMBER_REQUEST: `${NAME_SPACE}/FETCH_ADD_WORKING_CIRCLE_MEMBER_REQUEST`,
  FETCH_ADD_WORKING_CIRCLE_MEMBER_SUCCESS: `${NAME_SPACE}/FETCH_ADD_WORKING_CIRCLE_MEMBER_SUCCESS`,
  FETCH_ADD_WORKING_CIRCLE_MEMBER_FAILURE: `${NAME_SPACE}/FETCH_ADD_WORKING_CIRCLE_MEMBER_FAILURE`,
  FETCH_ADD_WORKING_CIRCLE_MEMBER: `${NAME_SPACE}/FETCH_ADD_WORKING_CIRCLE_MEMBER`,
  FETCH_REMOVE_WORKING_CIRCLE_MEMBER_REQUEST: `${NAME_SPACE}/FETCH_REMOVE_WORKING_CIRCLE_MEMBER_REQUEST`,
  FETCH_REMOVE_WORKING_CIRCLE_MEMBER_SUCCESS: `${NAME_SPACE}/FETCH_REMOVE_WORKING_CIRCLE_MEMBER_SUCCESS`,
  FETCH_REMOVE_WORKING_CIRCLE_MEMBER_FAILURE: `${NAME_SPACE}/FETCH_REMOVE_WORKING_CIRCLE_MEMBER_FAILURE`,
  FETCH_REMOVE_WORKING_CIRCLE_MEMBER: `${NAME_SPACE}/FETCH_REMOVE_WORKING_CIRCLE_MEMBER`,
  FETCH_SEARCH_PROFILES_REQUEST: `${NAME_SPACE}/FETCH_SEARCH_PROFILES_REQUEST`,
  FETCH_SEARCH_PROFILES_SUCCESS: `${NAME_SPACE}/FETCH_SEARCH_PROFILES_SUCCESS`,
  FETCH_SEARCH_PROFILES_FAILURE: `${NAME_SPACE}/FETCH_SEARCH_PROFILES_FAILURE`,
  FETCH_SEARCH_PROFILES: `${NAME_SPACE}/FETCH_SEARCH_PROFILES`,
  FETCH_PAIR_REPORT_SUGGESTION_REQUEST: `${NAME_SPACE}/FETCH_PAIR_REPORT_SUGGESTION_REQUEST`,
  FETCH_PAIR_REPORT_SUGGESTION_SUCCESS: `${NAME_SPACE}/FETCH_PAIR_REPORT_SUGGESTION_SUCCESS`,
  FETCH_PAIR_REPORT_SUGGESTION_FAILURE: `${NAME_SPACE}/FETCH_PAIR_REPORT_SUGGESTION_FAILURE`,
  FETCH_PAIR_REPORT_SUGGESTION: `${NAME_SPACE}/FETCH_PAIR_REPORT_SUGGESTION`,
}

export default constants
